import { TweenMax } from 'gsap';
import {wheel} from './wheel';

let modalSet = {
  isModal:false,
  modal: $('#l-modal'),
  modalContent: $('.modalContent'),
  close: $('.modalClose'),
  healthItem: $('.h-listItem'),
  active:"is-active",
};

export const modal={
  onClick:()=>{
    modalSet.healthItem.on(
      'click',
      (e)=>{
        let id=e.currentTarget.getAttribute('data-itemid');
        wheel.noMouseWheelEvt();
        modalSet.modal.addClass(modalSet.active);
        TweenMax.to(modalSet.modal,.5,{autoAlpha: 1});
        modalSet.modalContent.eq(id).addClass(modalSet.active);
      }
    );
    modalSet.close.on(
      'click',
      (e)=>{
        TweenMax.to(
          modalSet.modal,.3,
          {
            autoAlpha: 0,
            onComplete:()=>{
              modalSet.modal.removeClass(modalSet.active);
              wheel.mouseWheelEvt();
            }
        });
        modalSet.modalContent.removeClass(modalSet.active);
      }
    )
  },
  onClickNoScroll:()=>{
    modalSet.healthItem.on(
      'click',
      (e)=>{
        let id=e.currentTarget.getAttribute('data-itemid');
        // wheel.noMouseWheelEvt();
        modalSet.modal.addClass(modalSet.active);
        TweenMax.to(modalSet.modal,.5,{autoAlpha: 1});
        modalSet.modalContent.eq(id).addClass(modalSet.active);
      }
    );
    modalSet.close.on(
      'click',
      (e)=>{
        TweenMax.to(
          modalSet.modal,.3,
          {
            autoAlpha: 0,
            onComplete:()=>{
              modalSet.modal.removeClass(modalSet.active);
              // wheel.mouseWheelEvt();
            }
        });
        modalSet.modalContent.removeClass(modalSet.active);
      }
    )
  },
};